export const notesConstants = {
  NOTES_REQUEST: "NOTES_REQUEST",
  NOTES_SUCCESS: "NOTES_SUCCESS",
  NOTES_FAILURE: "NOTES_FAILURE",
};
